<template>
  <WModal hide-footer v-model="modal" size="sm" :title="$t('modal.inactivity.title')">
    <template #default>
      <NotificationBadge class="mx-0 badge-color-warning" :text="badgeText" color="warning-400" />

      <p class="text-base text-blue-500 my-3">
        {{ $t('modal.inactivity.content') }}
      </p>
    </template>
  </WModal>
</template>

<script setup lang="ts">
import { ref, computed, watch } from 'vue'
import { storeToRefs } from 'pinia'
import { useAuthStore } from '@/stores'
import { useI18n } from 'vue-i18n'
import { WModal } from '@wiosna-dev/wiosna-ui'

import NotificationBadge from '@/components/widgets/NotificationBadge.vue'

const authStore = useAuthStore()
const { inactivityModalVisible, timeToLogout } = storeToRefs(authStore)
const { t } = useI18n()

const modal = ref(false)

const badgeText = computed(() => t('modal.inactivity.logoutIn', { time: timeToLogout.value }))

watch(inactivityModalVisible, (newValue) => {
  modal.value = !!newValue.modal
})
</script>
